import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { CompanySettings } from "@/actions/ssr/settings/getCompanySettingsSSR";

const initialState: CompanySettings = {
  company_name: "",
  country: "",
  currency: "GBP",
  timezone: "Europe/London",
  email: "",
  phone_country_code: "GB",
  phone: "",
  logo_url: null,
};

const companySettingsSlice = createSlice({
  name: "companySettings",
  initialState,
  reducers: {
    setCompanySettings(state, action: PayloadAction<CompanySettings>) {
      return action.payload;
    },
    setCompanyLogoUrl(state, action: PayloadAction<string>) {
      state.logo_url = action.payload;
    },
  },
});

export const { setCompanySettings, setCompanyLogoUrl } =
  companySettingsSlice.actions;
export default companySettingsSlice.reducer;
